import jwt_decode from 'jwt-decode';

export const getUserData = () => {
    const userdata = document.cookie.split(';').find(x => x.trim().startsWith('userdata='));
    if (!userdata) return;

    const cookieString = decodeURIComponent(userdata).replace('userdata=', '');
    if (!cookieString) return;

    const cookie = JSON.parse(cookieString);
    if (!cookie || !cookie.access_token) return;

    const accessToken = jwt_decode(cookie.access_token);
    return accessToken;
};

export const getUserAuthorization = () => {
    const userdata = document.cookie.split(';').find(x => x.trim().startsWith('userdata='));
    if (!userdata) return;

    const cookieString = decodeURIComponent(userdata).replace('userdata=', '');
    if (!cookieString) return;

    const cookie = JSON.parse(cookieString);
    if (!cookie || !cookie.authorizations) return;

    return Object.keys(cookie.authorizations);
};

export const validateAuthUser = authorization => {
    try {
        const authorizations = getUserAuthorization();
        return authorizations.includes(authorization);
    } catch (e) {
        console.log(e);
    }
};
